import { localStorageService } from "./localStorage.service"

function parseJwt(token) {
  if (!token) return

  const base64Url = token?.split(".")[1]
  const base64 = base64Url?.replace(/-/g, "+")?.replace(/_/g, "/")
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join("")
  )

  return JSON.parse(jsonPayload)
}

function isJwtRefreshNeedIt() {
  const JWTAccessToken = localStorageService.getAccessToken()
  const JWTRefreshToken = localStorageService.getAccessRefreshToken()

  if (!JWTAccessToken && !JWTRefreshToken) {
    return true
  }

  const parsedJWT = parseJwt(JWTAccessToken ? JWTAccessToken : JWTRefreshToken)
  const tokenExpirationDate = new Date(parseInt(parsedJWT?.exp) * 1000)

  return parsedJWT ? new Date() > tokenExpirationDate : true
}
export const tokenService = {
  parseJwt,
  isJwtRefreshNeedIt,
  getAccessRefreshToken: localStorageService.getAccessRefreshToken,
  getAccessToken: localStorageService.getAccessToken
}
